// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"323":"ef58622a","326":"8f8d4269","517":"1cbb7155","719":"b95b57b6","787":"bc0c4390"}[chunkId] + ".chunk.js";
};